import React from 'react';
import {connect, DispatchProp} from "react-redux";
import {useTranslation, withTranslation} from "react-i18next";
import {RootState} from "../../../reducers";
import CartButtonComponent from "./CartButtonComponent";
import CartSummaryDataComponent from "./CartSummaryDataComponent";
import CartItemsComponent from "./CartItemsComponent";
import {ReactComponent as BasketIco} from "../../../images/icons/basket.svg";
import {getCart} from "../../services/Cart/reducer";
import CartCashbackComponent from "./CartCashbackComponent";
import CartVouchers from "./components/CartVouchers";
import CartSubmitInfoComponent from "./CartSubmitInfoComponent";

interface OwnProps {
    goToCart?: () => void;
    showVouchers?: boolean;
    stickySummary?: boolean;
}

type Props = ReturnType<typeof mapStateToProps> & OwnProps & DispatchProp;
const CartStickyComponent = (props: Props) => {
    const {t} = useTranslation();
    const cartCashbackComponentClassName = props.cart.items.length > 0 ? "mb-3" : "";

    return (
        <div className="cart-sticky sticky-fixed  sticky-fixed-cart fixed-height-100">
            <div className={"cart-sticky-container"}>
                <div className="cart-sticky-header">
                    <h3>
                        <BasketIco/>
                        {t("modules.cart.header.title")}
                        <span className="badge badge-light">{props.cart.items.length}</span>
                    </h3>
                </div>
                <div className={"cart-sticky-body position-relative"}>
                    <CartItemsComponent/>
                    {!props.stickySummary && <CartCashbackComponent className={cartCashbackComponentClassName}/>}
                    {props.cart.items.length > 0 && !props.stickySummary && <CartSummaryDataComponent/>}
                </div>
                <div className={"cart-sticky-footer"}>
                    {props.showVouchers && <CartVouchers/>}
                    {props.goToCart !== undefined && <CartButtonComponent goToCart={props.goToCart}/>}
                    {props.stickySummary && <CartCashbackComponent className={cartCashbackComponentClassName}/>}
                    {props.stickySummary && props.cart.items.length > 0 && <CartSummaryDataComponent/>}
                    <CartSubmitInfoComponent/>
                </div>
            </div>
        </div>
    )
}

const mapStateToProps = (state: RootState) => ({
    cart: getCart(state.cart)
})

const connector = connect(mapStateToProps);
export default withTranslation()(connector(CartStickyComponent));